// axios配置  可自行根据项目进行更改，只需更改该文件即可，其他文件可以不动

import { VAxios } from "./Axios";
import { AxiosTransform } from "./axiosTransform";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import qs from "qs";
// import { checkStatus } from "./checkStatus";
import { Modal, message as Message } from "ant-design-vue";
import { RequestEnum, ResultEnum, ContentTypeEnum } from "@/enums/httpEnum";

import { Api, RequestOptions, Result } from "./types";

import router from "@/router";
import store from "@/store";
import { Storage } from "@/utils/Storage";

// @ts-ignore
// @ts-ignore
/**
 * @description: 数据处理，方便区分多种处理方式
 */
const transform: AxiosTransform = {
  /**
   * @description: 处理请求数据
   */
  transformRequestData: (res: AxiosResponse<Result | Blob>, options: RequestOptions) => {
    return res.data;
    // const {
    //   isTransformRequestResult,
    //   isShowMessage = true,
    //   isShowErrorMessage,
    //   isShowSuccessMessage,
    //   successMessageText,
    //   errorMessageText
    // } = options;

    // const reject = Promise.reject;

    // let { data } = res;
    // if (!data) {
    //   return reject(res);
    // }
    // //  这里 code，result，message为 后台统一的字段，需要在 types.ts内修改为项目自己的接口返回格式
    // if (!Reflect.has(data, "code")) {
    //   return res;
    // } else {
    //   data = data as Result;
    // }
    // const { code, msg } = data;

    // // 请求成功
    // const hasSuccess = code === ResultEnum.SUCCESS;
    // // 是否显示提示信息
    // if (isShowMessage) {
    //   if (hasSuccess && (successMessageText || isShowSuccessMessage)) {
    //     // 是否显示自定义信息提示
    //     Message.success(successMessageText || msg || "操作成功！");
    //   } else if (!hasSuccess && (errorMessageText || isShowErrorMessage)) {
    //     // 是否显示自定义信息提示
    //     Message.error(msg || errorMessageText || "操作失败！");
    //   } else if (!hasSuccess && options.errorMessageMode === "modal") {
    //     // errorMessageMode=‘custom-modal’的时候会显示modal错误弹窗，而不是消息提示，用于一些比较重要的错误
    //     Modal.confirm({ title: "错误提示", content: msg });
    //   }
    // }
    // // 不进行任何处理，直接返回
    // // 用于页面代码可能需要直接获取code，data，message这些信息时开启
    // if (!isTransformRequestResult) {
    //   return res.data;
    // }

    // if (!data) {
    //   // return '[HTTP] Request has no return value';
    //   return reject(data);
    // }

    // // 接口请求成功，直接返回结果
    // if (code === ResultEnum.SUCCESS) {
    //   return data;
    // }
    // // 接口请求错误，统一提示错误信息
    // if (code === ResultEnum.ERROR) {
    //   if (msg) {
    //     Message.error(data.msg);
    //   } else {
    //     const msg = "操作失败,系统异常!";
    //     Message.error(msg);
    //   }
    //   return reject(new Error(msg));
    // }

    // // 登录超时
    // if (code === ResultEnum.TIMEOUT) {
    //   if (router.currentRoute.value.name == "login") return;
    //   // 到登录页
    //   const timeoutMsg = "登录超时,请重新登录!";
    //   Modal.destroyAll();
    //   Modal.warning({
    //     title: "提示",
    //     content: "登录身份已失效,请重新登录!",
    //     onOk: () => {
    //       router.replace({
    //         name: "login",
    //         query: {
    //           redirect: router.currentRoute.value.fullPath
    //         }
    //       });
    //       Storage.clear();
    //     }
    //   });
    //   return reject(new Error(timeoutMsg));
    // }

    // // 这里逻辑可以根据项目进行修改
    // if (!hasSuccess) {
    //   return reject(new Error(msg));
    // }

    // return data;
  },

  beforeRequestHook: (config: AxiosRequestConfig, options: RequestOptions) => {
    preproParams(config);
    if (config.headers) {
      const type = config.method;
      const defaults = {};
      const arrayFormat = (config.headers.arrayFormat || "repeat") as "indices" | "brackets" | "repeat" | "comma" | undefined;
      if (type === RequestEnum.POST) {
        if (config.headers["Content-Type"] == ContentTypeEnum.JSON) {
          config.data = config.params;
          config.params = null;
        } else {
          config.data = qs.stringify(config.params, {
            allowDots: true,
            indices: false,
            arrayFormat
          });
          config.data = qs.parse(config.data);
          config.params = null;
        }
      } else if (type === RequestEnum.GET || type === RequestEnum.DELETE) {
        // get请求参数处理
        config.params = qs.stringify(config.params);
        config.params = qs.parse(config.params);
        config.params = Object.assign(defaults, config.params, config.data);
        if (config.params && Object.keys(config.params).length) {
          config.url = config.url + "?" + qs.stringify(config.params, { indices: false, allowDots: true });
          config.params = null;
        }
      }
    }
    return config;
  },
  /**
   * @description: 请求拦截器处理
   */
  requestInterceptors: (config) => {
    // if (config.headers.noToken) {
    //   delete config.headers.noToken;
    // } else {
    //   // 请求之前处理config
    //   const token = store.state.user.token;
    //   if (token) {
    //     // jwt token
    //     config.headers.token = token;
    //   }
    // }
    // if (config.method?.toLocaleUpperCase() !== RequestEnum.GET) {
    //   // 对FORM_URLENCODED类型进行转换
    //   if (config.headers?.["Content-Type"] == ContentTypeEnum.FORM_URLENCODED) {
    //     // config.params = qs.stringify(config.params, { arrayFormat: 'brackets' })
    //     config.data = qs.stringify(config.data, { arrayFormat: "brackets" });
    //   }
    // }
    return config;
  },

  /**
   * @description: 响应错误处理
   */
  responseInterceptorsCatch: (error: any) => {
    console.log(error);
    const {
      response,
      response: {
        data: { code }
      },
      message
    } = error || {};
    const msg: string = response && response.data && response.data ? response.data.msg : "";
    const err: string = error.toString();
    try {
      if (code === "ECONNABORTED" && message.indexOf("timeout") !== -1) {
        Message.error("接口请求超时,请刷新页面重试!");
        return;
      }
      if (err && err.includes("Network Error")) {
        Modal.confirm({
          title: "网络异常",
          content: "请检查您的网络连接是否正常!"
        });
        return;
      }
    } catch (error: any) {
      throw new Error(error);
    }
    // 请求是否被取消
    const isCancel = axios.isCancel(error);
    if (!isCancel) {
      // checkStatus(code, msg);
    } else {
      console.warn(error, "请求被取消！");
    }
    return error;
  }
};

const Axios = new VAxios({
  timeout: 15 * 1000,
  // 基础接口地址
  // baseURL: globSetting.apiUrl,
  // 接口可能会有通用的地址部分，可以统一抽取出来
  // prefixUrl: prefix,
  // headers: { "Content-Type": ContentTypeEnum.FORM_URLENCODED },
  // 数据处理方式
  transform,
  // 配置项，下面的选项都可以在独立的接口请求中覆盖
  requestOptions: {
    // 默认将prefix 添加到url
    joinPrefix: true,
    // 需要对返回数据进行处理
    isTransformRequestResult: true,
    // post请求的时候添加参数到url
    joinParamsToUrl: false,
    // 格式化提交参数时间
    formatDate: true,
    // 消息提示类型
    errorMessageMode: "none"
  },
  withCredentials: false
});

function preproParams(config: AxiosRequestConfig) {
  if (config?.url?.includes("${")) {
    for (const key in config.params) {
      const word = "${" + key + "}";
      if (config.url.includes(word)) {
        config.url = config.url.replace(word, config.params[key]);
        delete config.params[key];
      }
    }
  }
}

export default Axios;
